import * as _ from 'lodash';
import { NotificationMessage } from 'src/app/interfaces/notification-message.interface';
import INotificationMessage = ZoneIQCalibration.INotificationMessage;

export class NotificationMessageModel implements NotificationMessage {
    Id: number;
    Type: number;
    Message: string;
    CreatedOn: string;
    ModifiedOn: string;

    constructor(data: INotificationMessage) {
        Object.assign(this, _.pick(data, ['Id', 'Type', 'Message', 'CreatedOn', 'ModifiedOn']));
    }

    static factory(data: INotificationMessage) {
        return new NotificationMessageModel(data);
    }
}
